import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import anime from 'animejs';

const SetWidth = styled.span.withConfig({ componentId: 'sc-q79fjy-0' })`
  // rough guess on width to prevent jumping
  width: ${(props) =>
    `${
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'endCount' does not exist on type 'Themed... Remove this comment to see the full error message
      props.endCount
    }`.length * 10}px;
  display: inline-block;
`;

type OwnProps = {
  startCount?: number;
  endCount: number;
  initialDelay?: number;
  animationDuration?: number;
  className?: string;
};

// @ts-expect-error ts-migrate(2456) FIXME: Type alias 'Props' circularly references itself.
type Props = OwnProps & typeof Odometer.defaultProps;

// @ts-expect-error ts-migrate(7022) FIXME: 'Odometer' implicitly has type 'any' because it do... Remove this comment to see the full error message
const Odometer = (props: Props) => {
  const { className, startCount, endCount, initialDelay, animationDuration } = props;
  const ref = useRef(null);

  useEffect(
    () =>
      anime({
        targets: ref.current,
        innerText: [startCount, endCount],
        autoplay: true,
        delay: initialDelay,
        duration: animationDuration,
        easing: 'easeOutQuint',
        round: 1,
      }).pause,
    [startCount, endCount, initialDelay, animationDuration]
  );

  // @ts-expect-error ts-migrate(2769) FIXME: Property 'endCount' does not exist on type 'Intrin... Remove this comment to see the full error message
  return <SetWidth className={className} endCount={endCount} ref={ref} />;
};

Odometer.defaultProps = {
  initialDelay: 1000,
  animationDuration: 2000,
};

export default Odometer;
